module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Leave-Credit/leave-credit-bulk/leave-credit-bulk-form/leave-credit-bulk-form.component.css
// module id = ./src/app/hrms/Leave-Credit/leave-credit-bulk/leave-credit-bulk-form/leave-credit-bulk-form.component.css
// module chunks = main